// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plugin-list-line {\n  list-style: none;\n  text-align: left; }\n\n.plugin-list-line:hover {\n  background-color: #505050;\n  color: #adadad; }\n\n.plugin-list {\n  padding: 0;\n  list-style-type: none; }\n\n.plugin-list-line-selected {\n  background-color: #505050;\n  color: #adadad; }\n", ""]);
// Exports
module.exports = exports;
